import Vue from 'vue'

const state = {
  formulario: [],
  formularios: [],
}

const getters = {
  getFormularios: state => {
    return state.formularios
  },
  getFormulario: state => {
    return state.formulario
  }
}

const mutations = {
  setFormulario (state, data) {
    state.formulario = data
  },
  setFormularios (state, data) {
    state.formularios = data
  }
}

const actions = {
  getFormularios (context, config) {
    Vue.http.get('api/formulario').then(response => {
      context.commit('setFormularios', response.body.data.data)
    })
  },
  getFormulario (context, id) {
    Vue.http.get('api/formulario/' + id).then(response => {
      context.commit('setFormulario', response.data.data)
    })
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/formularios.js